(function () {

    'use strict';

    angular.module('FotocApp')

        .component('frames', {

            templateUrl: (USE_TEMPLATE_CACHE ? '' : window.BASE_PATH + '../../src/') + 'editor/tools/frames.component.html',
            bindings: {},
            controller: ['$editorService', '$canvasService', '$scope', '$lang', '$window', '$timeout', function ($editorService, $canvasService, $scope, $lang, $window, $timeout) {

                var self = this;

                this.$canvasService = $canvasService;
                this.$editorService = $editorService;
                this.FOTOCEDITOR_EDITOR_ASSETS = FOTOCEDITOR_EDITOR_ASSETS;
                $scope.$lang = $lang;

                this.lastAllApply = 'NONE';

                this.$onInit = function () {


                }

                this.select = function ($color) {

                   $editorService.ui.lastFrameColorSelected = $color;
                   $canvasService.updateBorderColor($color)

                };


                this.selectAll = function ($color) {

                    this.lastAllApply = $color;
                    $editorService.ui.lastFrameColorSelected = $color;
                    $canvasService.updateBorderColor($color, true)

                }


            }]


        })

})();